import React, { PropsWithChildren } from 'react';
import styles from './PaymentSelector.module.scss';

/* Assets */
import visa from '../../../../assets/icons/shop/visa@3x.png';
import mastercard from '../../../../assets/icons/shop/mastercard@3x.png';
import pix from '../../../../assets/icons/shop/pix@3x.png';
import paypal from '../../../../assets/icons/shop/paypal@3x.png';

/* Translations */
import { useTranslation } from 'react-i18next';
import { tr } from '../../../../utils/translations/translator';

/* Providers */
import { usePaymentTypeContext } from '../../__providers__/PaymentTypeContext';

/* Interfaces */
import { PaymentTypesReversed } from '../../interfaces/payment_types';
import { useBuyerContext } from '../../__providers__/BuyerProvider';

interface PaymentSelectorProps {}

export const PaymentSelector: React.FC<
  PaymentSelectorProps & PropsWithChildren
> = ({ children }) => {
  const { t } = useTranslation();
  const { selectedPayment, setSelectedPayment } = usePaymentTypeContext();
  const {
    states: { country },
  } = useBuyerContext();
  return (
    <div className={styles.container}>
      <div
        className={
          selectedPayment === PaymentTypesReversed.Stripe
            ? styles.selectedBorder
            : styles.unselectedBorder
        }
        onClick={() => {
          setSelectedPayment(PaymentTypesReversed.Stripe);
        }}
        id={styles[PaymentTypesReversed.Stripe]}
      >
        <div className={styles.selectorTextWrapper}>
          <p className={styles.selectorText}>{tr(t, 'pay_with_card')}</p>
          <img src={visa} alt="visa logo" />
          <img src={mastercard} alt="mastercard logo" />
          <div className={styles.selectBtn}>
            <button
              className={
                selectedPayment === PaymentTypesReversed.Stripe
                  ? styles.selected
                  : styles.unselected
              }
            ></button>
          </div>
        </div>
        {selectedPayment === PaymentTypesReversed.Stripe && children}
      </div>

      <div
        className={
          selectedPayment === PaymentTypesReversed.Paypal
            ? styles.selectedBorder
            : styles.unselectedBorder
        }
        onClick={() => {
          setSelectedPayment(PaymentTypesReversed.Paypal);
        }}
        id={styles[PaymentTypesReversed.Paypal]}
      >
        <div className={styles.selectorTextWrapper}>
          <p className={styles.selectorText}>{tr(t, 'pay_with')}</p>
          <img src={paypal} alt="paypal logo" />
          <div className={styles.selectBtn}>
            <button
              className={
                selectedPayment === PaymentTypesReversed.Paypal
                  ? styles.selected
                  : styles.unselected
              }
            ></button>
          </div>
        </div>
      </div>

      {country === 'BR' && (
        <div
          className={
            selectedPayment === PaymentTypesReversed.Pix
              ? styles.selectedBorder
              : styles.unselectedBorder
          }
          onClick={() => {
            setSelectedPayment(PaymentTypesReversed.Pix);
          }}
          id={styles[PaymentTypesReversed.Pix]}
        >
          <div className={styles.selectorTextWrapper}>
            <p className={styles.selectorText}>Pagamento com Pix</p>
            <img src={pix} alt="pix logo" />
            <div className={styles.selectBtn}>
              <button
                className={
                  selectedPayment === PaymentTypesReversed.Pix
                    ? styles.selected
                    : styles.unselected
                }
              ></button>
            </div>
          </div>
          {selectedPayment === PaymentTypesReversed.Pix && children}
        </div>
      )}
    </div>
  );
};
